import { render } from "./RelatorioProdutosContrato.vue?vue&type=template&id=2fba47fe"
import script from "./RelatorioProdutosContrato.vue?vue&type=script&lang=js"
export * from "./RelatorioProdutosContrato.vue?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__